import styled from 'styled-components';

import {
  amaranth,
  paradigmLightBlue,
} from '@paradigm/design-system/src/colors';

import { BillingCredits } from '#/api/billing';

import { Card, SectionTitle, settingsTextPrimary } from './styles';

interface Props {
  readonly credits: BillingCredits;
}

export default function BalanceCard({ credits }: Props) {
  const { subscription, purchased, total } = credits;
  return (
    <Card data-testid="billing-balance-card">
      <SectionTitle>Credit balance</SectionTitle>
      <Total $negative={total < 0}>{total}</Total>
      <Buckets>
        <Bucket>
          <BucketLabel>Subscription</BucketLabel>
          <BucketValue>{subscription}</BucketValue>
        </Bucket>
        <Bucket>
          <BucketLabel>Purchased</BucketLabel>
          <BucketValue>{purchased}</BucketValue>
        </Bucket>
      </Buckets>
    </Card>
  );
}

const Total = styled.div<{ $negative: boolean }>`
  font-size: 28px;
  font-weight: 600;
  line-height: 1.1;
  color: ${({ $negative }) => ($negative ? amaranth : settingsTextPrimary)};
`;

const Buckets = styled.div`
  display: flex;
  gap: 32px;
  margin-top: 2px;
`;

const Bucket = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const BucketLabel = styled.span`
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: ${paradigmLightBlue};
  opacity: 0.8;
`;

const BucketValue = styled.span`
  font-size: 14px;
  color: ${settingsTextPrimary};
`;
